const CatcherGameSceneInit = () => {
  return (
    <a-scene
      // embedded
      webar-scene
      spawn
      shadow="type: pcfsoft"
      physics="debug: false; gravity: -0.5; "
      // physics="driver: ammo; iterations: 20; step: 1/120; debug: false;gravity: -0.5;"
      renderer="logarithmicDepthBuffer: true; colorManagement: true; precision: mediump"
      vr-mode-ui="enabled: false"
      xr-mode-ui="enabled: false"
      gltf-model="dracoDecoderPath: https://rhym.s3.ap-south-1.amazonaws.com/draco/"
      cursor="rayOrigin: mouse"
      raycaster="objects: .clickable"
    >
      <a-assets>
        <a-asset-item
          preload="auto"
          class="a-sound"
          id="collectsrc"
          src="https://s3.ap-south-1.amazonaws.com/vizaro.in/app/website/static/audio/collect.mp3"
          response-type="arraybuffer"
        ></a-asset-item>
      </a-assets>
      <a-light type="ambient" color="#ffffff"></a-light>

      <a-light type="directional" position="-1 2 1"></a-light>
      <a-camera
        id="camera"
        position="0 2 2"
        look-controls="reverseMouseDrag:true; touchEnabled: false"
      >
        <a-sound id="collectsound" src="#collectsrc"></a-sound>
      </a-camera>
      <a-entity
        id="webar_stage"
        grid="size: 10; divisions: 10; color: #00F; opacity: 0.3"
        position="0 0 -3"
        scale="3 3 3"
      >
        <a-entity>
          <a-entity id="entity_elements" visible="true"></a-entity>
        </a-entity>
      </a-entity>

      <a-light id="ambient-light" type="ambient" intensity="0.8"></a-light>
    </a-scene>
  );
};

export default CatcherGameSceneInit;
